import { Locale } from '@/interfaces/api/general/language';
import { Company } from '@/interfaces/vuex/company';
import { DepartmentsState } from '@/interfaces/vuex/department';
import { User } from '@/interfaces/vuex/user';

export interface AppNotification {
  messageKey: string;
  messageValues?: Record<string, string>;
  color?: string;
  showProgress?: boolean;
  content?: string;
}

export interface MainState {
  userProfile: User | null;
  company: Company | null;
  switchableCompanies: Company[]; // ユーザーが切り替え可能な企業のリスト
  departments: DepartmentsState | null;
  dashboardMiniDrawer: boolean;
  dashboardShowDrawer: boolean;
  notifications: AppNotification[];
  nonLoggedInUserLocale: Locale;
  initialized: boolean; // Do not persist this key.
  forceEnroll2Fa: boolean; // Do not persist this key.
  featureFlags: Record<string, boolean>;
  pollingIntervalOfFeatureFlags: NodeJS.Timeout | null;
}

type MainStateKeys = keyof MainState;

// These keys are used to determine which keys get persisted in local storage.
// It is important to keep this list in sync with the keys in MainState to
// avoid persisting outdated keys, which might also pose a security risk.
export const mainStateKeys: MainStateKeys[] = [
  'userProfile',
  'company',
  'switchableCompanies',
  'departments',
  'dashboardMiniDrawer',
  'dashboardShowDrawer',
  'notifications',
  'nonLoggedInUserLocale',
];
